import { Link } from 'react-router-dom'
import { Section, Button } from '@vanilla/ui'
import { ArrowLeft, Bug, Mail } from 'lucide-react'

export function VoxNoteSupport() {
  return (
    <Section className="py-20">
      <div className="mx-auto max-w-3xl">
        <Link
          to="/labs/apps/voxnote"
          className="mb-8 inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          VoxNote
        </Link>

        <h1 className="mb-4 text-4xl font-bold tracking-tight">Support</h1>

        <div className="mb-12 flex flex-wrap gap-4">
          <Button asChild>
            <a
              href="https://github.com/novastate/VoiceSnap/issues"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Bug className="mr-2 h-4 w-4" />
              Report an Issue
            </a>
          </Button>
          <Button variant="outline" asChild>
            <a href="mailto:info@khc.one">
              <Mail className="mr-2 h-4 w-4" />
              Contact Us
            </a>
          </Button>
        </div>

        <div className="space-y-8">
          <div>
            <h2 className="mb-4 text-xl font-semibold">Getting Started</h2>
            <p className="text-muted-foreground">
              VoxNote makes it easy to capture your thoughts with voice. Simply tap the
              record button, speak your mind, and let AI clean up your notes.
            </p>
          </div>

          <div>
            <h2 className="mb-4 text-xl font-semibold">FAQ</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-medium">Does VoxNote work offline?</h3>
                <p className="text-muted-foreground">
                  Yes! Voice transcription works completely offline using on-device
                  processing. AI refinement requires an internet connection.
                </p>
              </div>
              <div>
                <h3 className="font-medium">Where are my notes stored?</h3>
                <p className="text-muted-foreground">
                  All notes are stored locally on your device and synced via iCloud if
                  enabled. We never have access to your data.
                </p>
              </div>
              <div>
                <h3 className="font-medium">How do I export my notes?</h3>
                <p className="text-muted-foreground">
                  Tap the share button on any note to export as text, or use the bulk
                  export feature in Settings.
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="mb-4 text-xl font-semibold">Report an Issue</h2>
            <p className="text-muted-foreground">
              Found a bug or have a feature request? Open an issue on GitHub:{' '}
              <a
                href="https://github.com/novastate/VoiceSnap/issues"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                github.com/novastate/VoiceSnap/issues
              </a>
            </p>
          </div>

          <div>
            <h2 className="mb-4 text-xl font-semibold">Contact Us</h2>
            <p className="text-muted-foreground">
              For other inquiries, email us at{' '}
              <a href="mailto:info@khc.one" className="text-primary hover:underline">
                info@khc.one
              </a>
            </p>
          </div>
        </div>

        <p className="mt-16 text-center text-sm text-muted-foreground">
          © 2025 KHC Labs ·{' '}
          <Link to="/labs/apps/voxnote" className="text-primary hover:underline">
            VoxNote
          </Link>
        </p>
      </div>
    </Section>
  )
}
